export const namespace = 'cusEcommerce/';

export const CusEcommerceGetters = {
  GET_PARTS: namespace + 'getParts',
  GET_SUBMIT_PARTS_RESPONSE: namespace + 'getSubmitPartsResponse'
};

export const CusEcommerceActions = {
  GET_PART_QUOTE: namespace + 'getPartQuote',
  SEARCH_PARTS: namespace + 'searchParts',
  SUBMIT_PARTS: namespace + 'submitParts',
  SEND_MESSAGE: namespace + 'sendMessage'
};

export const CusEcommerceMutations = {
  SET_PART_LIST: namespace + 'setPartList'
};
